import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import Button from "components/base/Button";
import PageBreadcrumb from "components/common/PageBreadcrumb";
import { licencaBreadcrumbItems } from "data/licenca";
import { useState } from "react";
import { Alert, Form } from "react-bootstrap";

function Licenca() {
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const mutation = useMutation<any>({
    mutationFn: (newTodo) => {
      return axios.post(`/api/license/gerar`, newTodo);
    },
  });

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const form = event.currentTarget as HTMLFormElement;
      const cnpj = form.cnpj.value;
      const token = form.pub.value;
      const { hwid, kpub } = JSON.parse(token);
      console.log(token, hwid, kpub);
      const data = {
        cnpj,
        hwid,
        pub: kpub,
      };

      const response = await mutation.mutateAsync({
        ...data,
      } as any);

      console.log(response);

      if (response.status === 200) {
        setSuccess("Licença copiada para a área de transferência");
        navigator.clipboard.writeText(response.data);
      }
    } catch (error: any) {
      console.log(error);
      setError(error?.response?.data ?? error.message ?? "Erro desconhecido");
      setTimeout(() => {
        setError("");
      }, 5000);
    }
  };
  return (
    <div>
      <PageBreadcrumb items={licencaBreadcrumbItems} />
      <div className="mb-9">
        <h2 className="mb-5">Licença</h2>
        {error && <Alert variant={"phoenix-danger"}>{error}</Alert>}
        {success && <Alert variant={"phoenix-success"}>{success}</Alert>}
        <div className="mt-3 d-flex w-100 justify-content-center">
          <form className="w-50" onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="cnpj">
              <Form.Label htmlFor="cnpj">CNPJ</Form.Label>
              <Form.Control id="cnpj" name="cnpj" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="pub">
              <Form.Label htmlFor="pub">Token de implantação</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                id="pub"
                style={{
                  resize: "none",
                }}
              />
              <Form.Text className="text-muted">
                Criado em c:\app\ssl\token.txt.implantacao.txt durante a
                primeira inicialização
              </Form.Text>
            </Form.Group>

            <Button
              className="btn btn-primary w-100"
              type="submit"
              loading={mutation.isPending}
              loadingPosition="start"
            >
              Gerar
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Licenca;
